import { render, staticRenderFns } from "./LayoutMain.vue?vue&type=template&id=1ca5d578&scoped=true&"
import script from "./LayoutMain.vue?vue&type=script&lang=js&"
export * from "./LayoutMain.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMain.vue?vue&type=style&index=0&id=1ca5d578&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca5d578",
  null
  
)

export default component.exports